import { render, staticRenderFns } from "./DeltekData.vue?vue&type=template&id=0f2aa0f4"
import script from "./DeltekData.vue?vue&type=script&lang=js"
export * from "./DeltekData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports